import { Helmet } from "react-helmet-async";

const SITE_URL = process.env.REACT_APP_SITE_URL;
const DEFAULT_IMAGE = `${SITE_URL}/brand/hero-home-1920.jpg`;

export function SEO({ title, description, path = "", image, noindex = false }) {
  const fullTitle = title ? `${title} | Blueprint4Joy®` : "Blueprint4Joy®";
  const canonical = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Blueprint4Joy®" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
